import State from '../core/State';
import BankAccount from '../entity/BankAccount';
import BillUser from '../entity/BillUser';
import PaymentDetail from '../entity/PaymentDetail';
import PaymentExtProvider from '../entity/PaymentExtProvider';
import PaymentHistory from '../entity/PaymentHistory';
import ProductPricing from '../entity/ProductPricing';
import UserPayee from '../entity/UserPayee';
import ZenginBank from '../entity/ZenginBank';
import initialState from '../initialState';

export const setBillUser = (billUser: BillUser) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    billUser,
  },
});

export const setProductPricing = (productPricing: ProductPricing) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    productPricing,
  },
});

export const setZenginBank = (zenginBank?: ZenginBank) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    zenginBank: zenginBank || null,
  },
});

export const setZenginBankAgent = (zenginBankAgent?: ZenginBank) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    zenginBankAgent: zenginBankAgent || null,
  },
});

export const setUserPayee = (userPayee?: UserPayee) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    userPayee: userPayee || null,
  },
});

export const setUserPayeeAgent = (userPayeeAgent?: UserPayee) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    userPayeeAgent: userPayeeAgent || null,
  },
});

export const setBankAccount = (bankAccount?: BankAccount) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    bankAccount: bankAccount || null,
  },
});

export const setBankAccountAgent = (bankAccountAgent?: BankAccount) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    bankAccountAgent: bankAccountAgent || null,
  },
});

export const setPaymentHistory = (paymentHistory: PaymentHistory) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    paymentHistory,
  },
});

export const setPaymentHistoryAgent = (paymentHistoryAgent: PaymentHistory) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    paymentHistoryAgent,
  },
});

export const setPaymentDetails = (paymentDetails: PaymentDetail[]) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    paymentDetails,
  },
});

export const setPaymentDetailsAgent = (paymentDetailsAgent: PaymentDetail[]) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    paymentDetailsAgent,
  },
});

export const setPaymentExtProvider = (paymentExtProvider: PaymentExtProvider) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    paymentExtProvider,
  },
});

export const setPaymentExtProviderAgent = (paymentExtProviderAgent: PaymentExtProvider) => (state: State): State => ({
  ...state,
  acct: {
    ...state.acct,
    paymentExtProviderAgent,
  },
});

export const disposeAcct = () => (state: State): State => ({
  ...state,
  currentAcctAccount: initialState.currentAcctAccount,
  acct: {
    ...initialState.acct,
  },
});
